import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form1" }
const _hoisted_2 = { class: "story" }
const _hoisted_3 = { class: "panel" }
const _hoisted_4 = { class: "panel_left" }
const _hoisted_5 = { class: "image-slot" }
const _hoisted_6 = { class: "panel_right" }
const _hoisted_7 = { class: "example" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { style: {"white-space":"pre-wrap"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_icon_picture = _resolveComponent("icon-picture")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("h2", null, "编写故事剧本", -1)),
      _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
      _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_form, {
            model: _ctx.form,
            "label-width": "auto",
            style: {"max-width":"600px"},
            "label-position": "top",
            rules: _ctx.rules,
            ref: "ruleForm",
            "status-icon": ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "故事标题",
                prop: "storyTitle"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.storyTitle,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.storyTitle) = $event)),
                    size: "large"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "故事图",
                prop: "storyCover"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_upload, {
                    class: "avatar-uploader",
                    action: _ctx.UpdateApi,
                    "show-file-list": false,
                    "on-success": _ctx.handleAvatarSuccess,
                    "before-upload": _ctx.beforeAvatarUpload,
                    limit: 1,
                    "file-list": _ctx.fileList,
                    disabled: _ctx.allowUpload
                  }, {
                    default: _withCtx(() => [
                      (_ctx.form.storyCover)
                        ? (_openBlock(), _createBlock(_component_el_image, {
                            key: 0,
                            src: _ctx.form.storyCover,
                            class: "avatar",
                            alt: "",
                            fit: 'contain'
                          }, {
                            error: _withCtx(() => [
                              _createElementVNode("div", _hoisted_5, [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_icon_picture)
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 1
                          }, 8, ["src"]))
                        : (_openBlock(), _createBlock(_component_el_icon, {
                            key: 1,
                            class: "avatar-uploader-icon"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Plus)
                            ]),
                            _: 1
                          }))
                    ]),
                    _: 1
                  }, 8, ["action", "on-success", "before-upload", "file-list", "disabled"])
                ]),
                _: 1
              }),
              (_ctx.allowUpload)
                ? (_openBlock(), _createBlock(_component_el_form_item, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "warning",
                        onClick: _ctx.clearImage
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("settings.clearImg")), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_el_form_item, {
                label: "故事内容",
                prop: "storyDesc"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.storyDesc,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.storyDesc) = $event)),
                    type: "textarea",
                    size: "large",
                    rows: "10",
                    "show-word-limit": "",
                    maxlength: "1000"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[3] || (_cache[3] = _createElementVNode("p", { class: "title" }, "App示意图", -1)),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("img", {
              src: _ctx.form.storyCover,
              alt: ""
            }, null, 8, _hoisted_8),
            _createElementVNode("p", null, _toDisplayString(_ctx.form.storyTitle), 1),
            _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.form.storyDesc), 1),
            _cache[2] || (_cache[2] = _createElementVNode("p", null, [
              _createElementVNode("span", null, "继续")
            ], -1))
          ])
        ])
      ])
    ])
  ]))
}